import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import { Web3Provider } from 'react-web3';
import { BrowserRouter } from 'react-router-dom'

ReactDOM.render(
	(
	<BrowserRouter basename='/oyomecoin/'>
	  <Web3Provider>
	    <App />
	  </Web3Provider>
	</BrowserRouter>
	),
	document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js